module.exports = __webpack_public_path__ + "img/banner-referral-header.10df6803.png";